import { ArrowLeft, LogOut, User, Sun, Moon, Loader2, RefreshCw } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { useTheme } from '@/lib/ThemeProvider';
import { useCanGoBack } from '@/hooks/useCanGoBack';
import { brand } from '@/lib/branding';
import { FeedbackWidget } from '@/components/feedback/FeedbackWidget';

interface HeaderProps {
  onLogout: () => void;
  isSigningOut: boolean;
  onNavigateToProfile: () => void;
  userRole: 'admin' | 'user';
  userName?: string;
  etablissementNom?: string;
}

export function Header({ onLogout, isSigningOut, onNavigateToProfile, userRole, userName, etablissementNom }: HeaderProps) {
  const { theme, toggleTheme } = useTheme();
  const navigate = useNavigate();
  const showBack = useCanGoBack();

  return (
    <header className="flex items-center justify-between px-6 h-14 bg-header sticky top-0 z-50">
      {/* Section Gauche : Retour + Logo */}
      <div className="flex items-center gap-3">
        {showBack && (
          <Button
            variant="ghost"
            size="icon"
            onClick={() => navigate(-1)}
            aria-label="Retour"
            className="h-8 w-8 text-header-muted hover:text-white hover:bg-white/10 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
          </Button>
        )}
        <img src={brand.logoUrl} alt={brand.name} className="h-10 w-auto" />
      </div>

      {/* Section Droite : Actions Utilisateur */}
      <div className="flex items-center space-x-4">
        <Button variant="ghost" size="sm" onClick={() => window.location.reload()} aria-label="Actualiser" title="Actualiser" className="text-header-muted hover:text-white hover:bg-white/10 transition-colors">
          <RefreshCw className="w-4 h-4" />
        </Button>
        <Button variant="ghost" size="sm" onClick={toggleTheme} className="text-header-muted hover:text-white hover:bg-white/10 transition-colors">
          {theme === 'light' ? <Moon className="w-4 h-4" /> : <Sun className="w-4 h-4" />}
        </Button>
        <FeedbackWidget />
        <Button variant="ghost" size="sm" onClick={onNavigateToProfile} className="text-header-foreground hover:bg-white/10 [&>svg]:text-header-muted [&>svg]:hover:text-white">
          <User className="w-4 h-4 mr-2 transition-colors" />
          <span>{userRole === 'admin' ? `Admin ${brand.name}` : (userName && etablissementNom ? `${userName} (${etablissementNom})` : userName || 'Utilisateur')}</span>
        </Button>
        <Button variant="ghost" size="sm" onClick={onLogout} disabled={isSigningOut} aria-label="Déconnexion" className="text-header-muted hover:text-white hover:bg-white/10 transition-colors">
          {isSigningOut ? <Loader2 className="w-4 h-4 animate-spin" /> : <LogOut className="w-4 h-4" />}
        </Button>
      </div>
    </header>
  );
}
